import React from 'react';

const AboutAlt2 = () => {
  const stats = [
    {
      title: 'REVENUE GENERATED',
      value: '75+',
      suffix: 'MILLION',
    },
    {
      title: 'WORKED IN',
      value: '20+',
      suffix: 'COUNTRIES',
    },
    {
      title: 'WORKED IN',
      value: '30+',
      suffix: 'CATEGORIES',
    },
  ];

  return (
    <section className="bg-black text-white py-12 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        {/* Header with Asymmetric Design */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-16">
          <div className="space-y-6">
            <div className="inline-block bg-primary/20 text-primary px-6 py-2 rounded-full text-sm font-medium backdrop-blur-sm">
              ABOUT US
            </div>
            <h2 className="text-4xl md:text-5xl font-bold">
              More Than Just an Amazon Partner We Put Your Growth First
            </h2>
          </div>
          <div className="flex items-center">
            
            <p className="text-lg text-white/80 leading-relaxed">
            Maximize your Amazon potential with our expert team of professionals. With over 5 years of experience and a deep understanding of the Amazon marketplace, we specialize in turning clicks into conversions. From optimized product listings to targeted advertising and creative content, we simplify your path to success. Our personalized strategies boost your sales, increase brand visibility, and help you stay ahead of the competition.
            </p>
          </div>
        </div>

        {/* Stats with Modern Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div
              key={stat.title}
              className="relative group"
            >
              {/* Background Card */}
              <div className="absolute inset-0 bg-primary/10 rounded-2xl transform group-hover:translate-x-2 group-hover:translate-y-2 transition-transform duration-300" />
              
              {/* Main Card */}
              <div className="relative bg-black/80 backdrop-blur-xl border border-white/10 rounded-2xl p-8 transform transition-transform duration-300">
                <div className="absolute -top-2 -right-2 w-12 h-12 bg-primary rounded-lg transform -rotate-12 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                <h3 className="text-sm font-medium text-white/60 mb-4">{stat.title}</h3>
                <div className="flex items-baseline gap-1">
                  <span className="text-5xl font-bold">{stat.value}</span>
                  <span className="text-2xl font-bold">{stat.suffix}</span>
                  {stat.subtitle && (
                    <span className="text-xl font-medium text-white/60 ml-2">
                      {stat.subtitle}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutAlt2;
